import { UserGroupIcon, UsersIcon, RefreshIcon, CreditCardIcon, CalendarIcon } from "@heroicons/react/outline";
const API_HOST = `${process.env.REACT_APP_HOST}`;
export const isContactsSupported =
  "contacts" in navigator && "ContactsManager" in window;
export const isMobile = /Mobi|Android|iPhone|iPad/i.test(
  navigator.userAgent
);
export const HOST = API_HOST;
export const API_URL = `${process.env.REACT_APP_API_URL}`;
export const AVATAR_URL = `${process.env.REACT_APP_AVATAR_URL}`;
export const INSURANCE_URL = `${process.env.REACT_APP_INSURANCE_URL}`;
export const STATUS_URL = `${process.env.REACT_APP_STATUS_URL}`;
export const ALLOWED_FILE_TYPE = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/jpg",
];

export const BOTTOM_NAV = [
  {
    name: "Breathe",
    icon: <RefreshIcon className="h-6 w-6" />,
    id: "tour-tab-breathe-m",
  },
  {
    name: "Social",
    icon: <UserGroupIcon className="h-6 w-6" />,
    id: "tour-tab-social-m",
  },
  {
    name: "Wallet",
    icon: <CreditCardIcon className="h-6 w-6" />,
    id: "tour-tab-wallet-m",
  },
  {
    name: "Calendar",
    icon: <CalendarIcon className="h-6 w-6" />,
    id: "tour-tab-calendar-m",
  },
  {
    name: "People",
    icon: <UsersIcon className="h-6 w-6" />,
    id: "tour-tab-people-m",
  },
];
